import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { formRules } from "@/js/form_rules.js";
import { listUserGroups, expeditionMethods, getOrderStatusShortLabel } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormAdd = {
  customerId: null,
  departureWarehouseId: null,
  arrivalWarehouseId: null,
  subOrderIds: [],
  valid: false
};
export default {
  name: "NewContainerOrderModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      dialog: false,
      isAllowed: false,
      addingOrder: {
        form: _objectSpread({}, defaultFormAdd),
        isPending: false,
        cancellationToken: null,
        subordersInputSearch: ""
      },
      gettingCompatibleOrders: {
        isPending: false,
        cancellationToken: null,
        result: []
      },
      gettingCustomers: {
        isPending: false,
        cancellationToken: null,
        result: []
      },
      gettingWarehouses: {
        isPending: false,
        cancellationToken: null,
        result: []
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingOrder.isPending;
    },
    availableArrivalWarehouses: function availableArrivalWarehouses() {
      var _this$gettingWarehous,
        _this2 = this;
      if (+((_this$gettingWarehous = this.gettingWarehouses.result) === null || _this$gettingWarehous === void 0 ? void 0 : _this$gettingWarehous.length) <= 0 || +this.addingOrder.form.customerId <= 0) return [];
      var customer = this.gettingCustomers.result.find(function (x) {
        return x.id_user === _this2.addingOrder.form.customerId;
      });
      return this.gettingWarehouses.result.filter(function (x) {
        return x.id !== _this2.addingOrder.form.departureWarehouseId && x.address.country.id_country === customer.delivery_address.country.id_country;
      });
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.isAllowed = isAdminNotConsultant(_this3.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_ORDER);
            if (_this3.isAllowed) {
              _this3.getCustomers();
              _this3.getWarehouses();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    addOrder: function addOrder() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$addingOrder$can;
        var _this, _this4$addingOrder$fo, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.addingOrder.isPending = true;
              _this = _this4;
              (_this$addingOrder$can = _this.addingOrder.cancellationToken) === null || _this$addingOrder$can === void 0 || _this$addingOrder$can.cancel();
              _this.addingOrder.cancellationToken = axios.CancelToken.source();
              _this4$addingOrder$fo = _this4.addingOrder.form, valid = _this4$addingOrder$fo.valid, withoutValid = _objectWithoutProperties(_this4$addingOrder$fo, _excluded);
              _context3.next = 7;
              return request("/v1/container-orders/", "post", withoutValid, true, "api", null, _this.addingOrder.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingOrder.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to create the container order.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _this4.addingOrder.isPending = false;
              _this4.$toasted.show("Container order created.", {
                type: "success"
              });
              _this4.$emit("entityCreated");
              _this4.close();
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changeDepartureWarehouseId: function changeDepartureWarehouseId() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this5.addingOrder.form.arrivalWarehouseId === null || _this5.addingOrder.form.arrivalWarehouseId === _this5.addingOrder.form.departureWarehouseId) {
                _this5.addingOrder.form.arrivalWarehouseId = null;
                _this5.gettingCompatibleOrders.result = [];
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeDepartureArrivalId: function changeDepartureArrivalId() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this6.addingOrder.form.arrivalWarehouseId > 0) {
                _this6.getCompatibleOrders();
              } else {
                _this6.gettingCompatibleOrders.result = [];
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getCompatibleOrders: function getCompatibleOrders() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$gettingCompatib;
        var _this, customer, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.gettingCompatibleOrders.isPending = true;
              _this7.addingOrder.form.subOrderIds = [];
              _this = _this7;
              (_this$gettingCompatib = _this.gettingCompatibleOrders.cancellationToken) === null || _this$gettingCompatib === void 0 || _this$gettingCompatib.cancel();
              _this.gettingCompatibleOrders.cancellationToken = axios.CancelToken.source();
              customer = _this7.gettingCustomers.result.find(function (x) {
                return x.id_user === _this7.addingOrder.form.customerId;
              });
              dataForSearch = {
                departureWarehouseId: +_this7.addingOrder.form.departureWarehouseId,
                arrivalWarehouseId: +_this7.addingOrder.form.arrivalWarehouseId,
                currency: customer.default_currency
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context6.next = 10;
              return request("/v1/container-orders/compatible-orders?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingCompatibleOrders.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingCompatibleOrders.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load compatible orders.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context6.sent;
              _this7.gettingCompatibleOrders.result = _toConsumableArray(response.data.value.map(function (x) {
                var _Object$values$find$t, _Object$values$find, _x$delivery_address$s, _x$delivery_address$s2;
                var formattedPrice = "".concat(formatPrice(x.total_amount_currency), " ").concat(getSymbolCurrency(x.currency));
                var nbBtls = x.items.reduce(function (acc, x) {
                  return acc + x.quantity;
                }, 0);
                var expMethod = (_Object$values$find$t = (_Object$values$find = Object.values(expeditionMethods).find(function (em) {
                  return em.id === x.expedition_method;
                })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.text) !== null && _Object$values$find$t !== void 0 ? _Object$values$find$t : "missing expedition method";
                x.displayLabel = "#".concat(x.reference_order.shorterReference(), " ").concat(x.delivery_address.country.iso_code).concat((_x$delivery_address$s = x.delivery_address.state) !== null && _x$delivery_address$s !== void 0 && _x$delivery_address$s.iso_state ? "-" + ((_x$delivery_address$s2 = x.delivery_address.state) === null || _x$delivery_address$s2 === void 0 ? void 0 : _x$delivery_address$s2.iso_state) : "", ", ").concat(getFullNameUser(x.user), " : ").concat(formattedPrice, ", ").concat(nbBtls, " btls, ").concat(expMethod, ", ").concat(getOrderStatusShortLabel(x.status));
                return x;
              }));
              _this7.gettingCompatibleOrders.isPending = false;
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getCustomers: function getCustomers() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this$gettingCustomer;
        var _this, response, values;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.gettingCustomers.isPending = true;
              _this = _this8;
              (_this$gettingCustomer = _this.gettingCustomers.cancellationToken) === null || _this$gettingCustomer === void 0 || _this$gettingCustomer.cancel();
              _this.gettingCustomers.cancellationToken = axios.CancelToken.source();
              _context7.next = 6;
              return request("/v1/third-party-users", "get", {}, true, "api", null, _this.gettingCustomers.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, "Unable to get list of customers", true);
                handleErrorData(_this, errorData);
                _this.gettingCustomers.isPending = false;
                throw e;
              });
            case 6:
              response = _context7.sent;
              values = _toConsumableArray(response.data.value);
              _this8.gettingCustomers.result = [];
              values.forEach(function (user) {
                if (user.user_group !== "USER") {
                  var _user$delivery_addres, _listUserGroups$find;
                  var fullName = getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + ((_user$delivery_addres = user.delivery_address.state) !== null && _user$delivery_addres !== void 0 && _user$delivery_addres.iso_state ? "-".concat(user.delivery_address.state.iso_state) : "") + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                    return x.id === user.user_group.toUpperCase();
                  })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.emailAdressToContact + ")";
                  _this8.gettingCustomers.result.push(_objectSpread(_objectSpread({}, user), {}, {
                    full_name: fullName
                  }));
                }
              });
              _this8.gettingCustomers.result.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this8.gettingCustomers.isPending = false;
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getWarehouses: function getWarehouses() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this$gettingWarehous2;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.gettingWarehouses.isPending = true;
              _this = _this9;
              (_this$gettingWarehous2 = _this.gettingWarehouses.cancellationToken) === null || _this$gettingWarehous2 === void 0 || _this$gettingWarehous2.cancel();
              _this.gettingWarehouses.cancellationToken = axios.CancelToken.source();
              _context8.next = 6;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api", null, _this.gettingWarehouses.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                _this.gettingWarehouses.isPending = false;
                throw e;
              });
            case 6:
              response = _context8.sent;
              _this9.gettingWarehouses.result = _toConsumableArray(response.data.warehouses);
              _this9.gettingWarehouses.isPending = false;
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    open: function open() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.resetData();
              _this10.dialog = true;
              return _context9.abrupt("return", new Promise(function (resolve, reject) {
                _this10.resolve = resolve;
                _this10.reject = reject;
              }));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      //not needed, at any dialog close, the component is destroyed
      this.addingOrder.form = _objectSpread({}, defaultFormAdd);
    },
    filterVAutocomplete: filterVAutocomplete
  }
};